import { ImageProps } from "../../types";
import { getDataFromLocalStorage } from "../../utils/localStorage";
import ProgressiveImage from "../progressiveImage/ProgressiveImage";
import {
  Container,
  Label,
  PreviewImage,
  Action,
  ImgVerticalMiddle,
  PositionLabel,
} from "./ShowBgImage.styles";
import PlaceHolderImage from "../../assets/images/placeholder.svg";
import TrashIcon from "../../assets/icons/trash.svg";
import EditIcon from "../../assets/icons/edit.svg";

function ShowBgImage(props: ImageProps) {
  const { file, onFileChange, openModal } = props;
  const { image_url } = getDataFromLocalStorage("clinicData") || {};

  return (
    <Container file={file || image_url}>
      <div>
        <input type="file" onChange={onFileChange} id="myinput" hidden />

        {file || image_url ? (
          <Action>
            <Label htmlFor="myinput">
              <ImgVerticalMiddle>
                <img src={EditIcon} alt="Edit" />
              </ImgVerticalMiddle>
              <span>Edit</span>
            </Label>
            <Label onClick={openModal}>
              <ImgVerticalMiddle>
                <img src={TrashIcon} alt="Delete" />
              </ImgVerticalMiddle>
              <span style={{ color: "rgba(202, 43, 29, 1)" }}>Delete</span>
            </Label>
          </Action>
        ) : (
          <PositionLabel htmlFor="myinput">{"+ Add image"}</PositionLabel>
        )}
      </div>
      {(file || image_url) && (
        <div>
          {/* <PreviewImage src={file || image_url} alt="my-image" /> */}
          <ProgressiveImage
            src={file || image_url}
            alt="my-image"
            imageComponent={PreviewImage}
            placeHolderSrc={PlaceHolderImage}
          />
        </div>
      )}
    </Container>
  );
}

export default ShowBgImage;
